<!-- Modern Profile Dropdown with Tailwind -->
<div class="relative inline-block">
  <!-- Profile Button -->
  <button
    (click)="toggleDropdown()"
    class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
    type="button"
  >
    <!-- Avatar with Initials -->
    <div class="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold text-sm shadow-md">
      {{ userInitials }}
    </div>

    <!-- User Info -->
    <div class="hidden md:flex flex-col items-start">
      <span class="text-sm font-medium text-gray-900">{{ userName }}</span>
      <span class="text-xs text-gray-500">{{ userRole }}</span>
    </div>

    <!-- Dropdown Arrow -->
    <i class="fa fa-angle-down text-gray-400 transition-transform duration-200"
       [class.rotate-180]="isDropdownOpen"></i>
  </button>

  <!-- Dropdown Menu with Click-based Toggle -->
  <div
    *ngIf="isDropdownOpen"
    class="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-gray-100 py-2 z-50 animate-fade-in"
  >
    <!-- User Info in Dropdown (Mobile) -->
    <div class="md:hidden px-4 py-3 border-b border-gray-100">
      <p class="text-sm font-medium text-gray-900">{{ userName }}</p>
      <p class="text-xs text-gray-500">{{ userRole }}</p>
    </div>

    <!-- Menu Items -->
    <a
      (click)="navigateTo('/user/profile')"
      class="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-150 cursor-pointer"
    >
      <app-feather-icons [icon]="'user'" class="w-4 h-4"></app-feather-icons>
      <span>{{ 'Header.Account' | translate }}</span>
    </a>

    <a
      (click)="navigateTo('/faq')"
      class="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-150 cursor-pointer"
    >
      <app-feather-icons [icon]="'settings'" class="w-4 h-4"></app-feather-icons>
      <span>{{ 'Header.Settings' | translate }}</span>
    </a>

    <!-- Divider -->
    <div class="my-1 border-t border-gray-100"></div>

    <!-- Logout -->
    <button
      (click)="logoutFunc()"
      class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150 cursor-pointer"
    >
      <app-feather-icons [icon]="'log-out'" class="w-4 h-4"></app-feather-icons>
      <span>{{ 'Header.LogOut' | translate }}</span>
    </button>
  </div>
</div>

<!-- Backdrop to close dropdown when clicking outside -->
<div
  *ngIf="isDropdownOpen"
  (click)="closeDropdown()"
  class="fixed inset-0 z-40"
></div>
